// API Configuration for ASOS Vendor Management System
// Supports httpOnly cookie-based authentication

// Environment-aware API base URL
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';

// Request timeout (15 seconds for most requests)
export const API_TIMEOUT = 15000;

// Email operation timeout (90 seconds for sending emails with attachments)
export const EMAIL_TIMEOUT = 90000;

// Long-running request timeout (5 minutes for uploads)
export const UPLOAD_TIMEOUT = 300000;

// Retry configuration
// Note: 429 (Too Many Requests) should NOT be retried as it will make the problem worse
export const RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: 1000, // Base delay in ms (exponential backoff)
  retryOn: [408, 500, 502, 503, 504], // HTTP status codes to retry (429 excluded)
};

// Axios configuration with credentials for httpOnly cookies
export const axiosConfig = {
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  withCredentials: true, // Required for httpOnly cookies
  maxBodyLength: 100 * 1024 * 1024, // 100MB - matches backend limit
  maxContentLength: 100 * 1024 * 1024, // 100MB
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

// Upload-specific axios config
export const uploadConfig = {
  ...axiosConfig,
  timeout: UPLOAD_TIMEOUT,
  maxBodyLength: 100 * 1024 * 1024, // 100MB
  maxContentLength: 100 * 1024 * 1024, // 100MB
  headers: {
    'Accept': 'application/json',
    // Content-Type will be set automatically for FormData
  },
};
